export default function systemStatusService(SYSTEM_STATUS, $http) {
    "ngInject";
    return {
        getSystemStatus: getSystemStatus,
        hasMaintenanceStatusCode: hasMaintenanceStatusCode,
        isOperational: isOperational,
    };

    ////////////////////////////////
    //                            //
    //         PUBLIC API         //
    //                            //
    ////////////////////////////////

    function getSystemStatus() {
        return $http
            .get(`/api/v1/health`, {
                timeout: 3000,
            })
            .then(function (response) {
                return createSystemStatus(
                    SYSTEM_STATUS.OPERATIONAL,
                    response.status
                );
            })
            .catch(function (error) {
                return createSystemStatus(
                    SYSTEM_STATUS.MAINTENANCE,
                    error && error.status
                );
            });
    }

    function hasMaintenanceStatusCode(systemStatus) {
        return getHttpStatusCode(systemStatus) === 503;
    }

    function isOperational(systemStatus) {
        return getStatus(systemStatus) === SYSTEM_STATUS.OPERATIONAL;
    }

    function getStatus(systemStatus) {
        if (angular.isObject(systemStatus)) {
            return systemStatus.status;
        }

        return systemStatus;
    }

    function getHttpStatusCode(systemStatus) {
        if (!angular.isObject(systemStatus)) {
            return undefined;
        }

        return systemStatus.httpStatusCode;
    }

    function createSystemStatus(status, httpStatusCode) {
        return {
            status: status,
            httpStatusCode: httpStatusCode,
        };
    }
}
